export type BackendDbStatus = {
  ok: boolean;
  target: string;
  checkedAt: string;
  error?: string;
  hints?: string[];
};

/** Consulta GET /api/health/db del backend (sin auth). */
export async function fetchBackendDbStatus(
  backendBaseUrl: string,
): Promise<BackendDbStatus> {
  const base = backendBaseUrl.replace(/\/$/, '');
  const url = `${base}/api/health/db`;

  let res: Response;
  try {
    res = await fetch(url, { method: 'GET' });
  } catch (err) {
    return {
      ok: false,
      target: base,
      checkedAt: new Date().toISOString(),
      error: `No se pudo contactar el backend (${url}): ${
        err instanceof Error ? err.message : String(err)
      }`,
      hints: [
        'Revisa que el backend esté arriba y BACKEND_BASE_URL sea la URL pública correcta (sin :7007 detrás de Traefik).',
      ],
    };
  }

  let body: Partial<BackendDbStatus> = {};
  try {
    body = (await res.json()) as Partial<BackendDbStatus>;
  } catch {
    body = {};
  }

  if (!res.ok || body.ok === false) {
    return {
      ok: false,
      target: body.target ?? base,
      checkedAt: body.checkedAt ?? new Date().toISOString(),
      error: body.error ?? `El backend respondió HTTP ${res.status} en ${url}`,
      hints: body.hints,
    };
  }

  return {
    ok: true,
    target: body.target ?? base,
    checkedAt: body.checkedAt ?? new Date().toISOString(),
  };
}
